import { FC } from 'react';

import {
  ClientCardInfo,
  CustomerAccountRow,
  PaginatedList,
} from '~/components';
import { customerAccountsColumns, formatPhone } from '~/utils';
import { Column, ContentBox, PaginatedListBox, Title, Wrapper } from './styles';

type Props = {
  customer: Customer;
  customerAccounts: CustomerAccount[];
  isAccountsLoading: boolean;
  onPressAccount(account: CustomerAccount): void;
  onShowCustomerData(): void;
};

const CustomerAccounts: FC<Props> = ({
  customer,
  customerAccounts,
  isAccountsLoading,
  onPressAccount,
  onShowCustomerData,
}) => {
  return (
    <Wrapper titlePage="Contas do customer">
      <ContentBox>
        <Column>
          <ClientCardInfo
            name={customer?.name}
            email={customer?.email}
            phone={formatPhone(customer?.phone)}
            address={`${customer?.type || ''} - ${customer?.refDocument || ''}`}
            onPressSeeData={onShowCustomerData}
          />
        </Column>
        <PaginatedListBox>
          <Title>Contas Vinculadas</Title>
          <PaginatedList
            columns={customerAccountsColumns}
            list={customerAccounts}
            showPagination={false}
            isLoading={isAccountsLoading}
            renderList={(customerAccount) => (
              <CustomerAccountRow
                bankNumber={
                  customerAccount?.account?.settlementAccount?.bankNumber
                }
                branchNumber={
                  customerAccount?.account?.settlementAccount?.branchNumber
                }
                accountNumber={
                  customerAccount?.account?.settlementAccount?.accountNumber
                }
                accountDigit={
                  customerAccount?.account?.settlementAccount?.accountDigit
                }
                accountStatus={customerAccount?.account?.accountStatus}
                createdAt={customerAccount?.account?.createdAt}
                globalBalance={customerAccount?.globalBalance}
                onPress={() => onPressAccount(customerAccount)}
                key={customerAccount?.account?.id}
              />
            )}
            titleEmptyData="Nenhuma conta vinculada"
            descriptionEmptyData="O customer ainda não possui nenhuma conta vinculada"
          />
        </PaginatedListBox>
      </ContentBox>
    </Wrapper>
  );
};

export default CustomerAccounts;
